import React, { SetStateAction } from 'react';
import { Button } from 'antd';

import { TVSSearchParams } from 'shared/types/types';
import { IconExclamation } from 'shared/ui/form/icons/iconExclamation';

import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { useAppSelector } from 'app/store';
import style from './index.module.scss';

type TProps = {
  setCurrentSearchValue: React.Dispatch<SetStateAction<string | undefined>>;
  employeesTriger: (obj: TVSSearchParams) => void;
  filterState: { divisionId: string; filterEmployees: string; filterRequestStatuses: boolean; active: boolean };
  currentPage: number;
  currentSize: number;
  currentYear: number;
};

const NotFoundResults = ({
  setCurrentSearchValue,
  employeesTriger,
  filterState,
  currentPage,
  currentSize,
  currentYear,
}: TProps) => {
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const resetResults = async () => {
    const querryParams: TVSSearchParams = {
      year: currentYear,
      size: currentSize,
      page: currentPage,
      filterEmployees: filterState.filterEmployees,
      filterRequestStatuses: filterState.filterRequestStatuses ? ['consideredByHR'] : undefined,
      divisionId: filterState.divisionId ? filterState.divisionId : undefined,
      allAvailableOrganizations,
    };
    // асинхронность нужна, чтоб при очистке при setCurrentSearchValue не появлсялся компонент Empty
    // т.к. в компоненте стоит условие
    await employeesTriger(querryParams);
    setCurrentSearchValue('');
  };

  return (
    <div className={style.wrap}>
      <IconExclamation />
      <div className={style.title}>Поиск не дал результатов</div>
      <h5 className={style.subTitle}>Измените параметры поиска</h5>
      <Button type="primary" onClick={resetResults}>
        Очистить поиск
      </Button>
    </div>
  );
};

export default NotFoundResults;
